import React from 'react';
import { Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import ReceiptList from '../components/ReceiptScanner/ReceiptList';
import ReceiptDetail from '../components/ReceiptScanner/ReceiptDetail';

/**
 * Receipt Management Page
 * 
 * This page provides a UI for managing receipts, including uploading, viewing, and editing.
 */
function ReceiptManagement({ onAddTransaction, activeWorkspace = null, transactions = [] }) {
  // Get the current location
  const location = useLocation();
  
  // Determine which tab is active
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/receipts/') && !path.includes('/upload')) return 'detail';
    return 'list';
  };
  
  const activeTab = getActiveTab();
  
  return (
    <div className="receipt-management overflow-x-hidden">
      <div className="bg-white shadow">
        <div
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
          style={{ paddingTop: 'var(--safe-top, 0px)' }}
        >
          <div className="py-3 sm:h-16 sm:py-0 flex items-center justify-between gap-3">
            <div className="flex min-w-0 flex-1 items-center gap-3 sm:gap-8">
              <div className="flex-shrink min-w-0 flex items-center">
                <Link
                  to="/"
                  className="inline-flex items-center self-start px-3 py-2 text-base font-semibold text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition break-words sm:text-sm sm:font-medium sm:text-gray-500 sm:hover:text-gray-700 sm:bg-transparent sm:px-0 sm:py-0"
                >
                  Back to Dashboard
                </Link>
              </div>
              <div className="flex min-w-0 items-center">
                <Link
                  to="/receipts"
                  className={`${
                    activeTab === 'list'
                      ? 'border-indigo-500 text-gray-900'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                  } inline-flex items-center px-1 pt-1 border-b-2 text-base sm:text-sm font-medium`}
                >
                  All Receipts
                </Link>
              </div>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:items-center">
              <button
                type="button"
                className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <span className="sr-only">View notifications</span>
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
        <Routes>
          <Route path="/receipts" element={<ReceiptList activeWorkspace={activeWorkspace} />} />
          <Route path="/receipts/upload" element={<Navigate to="/receipts" replace />} />
          <Route
            path="/receipts/:id"
            element={<ReceiptDetail onAddTransaction={onAddTransaction} activeWorkspace={activeWorkspace} transactions={transactions} />}
          />
        </Routes>
      </div>
    </div>
  );
}

export default ReceiptManagement;
